import { render, staticRenderFns } from "./ActionSummaryCard.vue?vue&type=template&id=36f583d9"
import script from "./ActionSummaryCard.vue?vue&type=script&lang=js"
export * from "./ActionSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports